import ListingChipsContainer from './ListingChipsContainer';

export default ListingChipsContainer;
